import React from 'react';

const ShareButton = ({ onClick, buttonType }) => {
  return (
    <button
      type={'button'}
      className={`button-default share-button ${buttonType === buttonType && buttonType}`}
      aria-label={'share'}
      onClick={onClick}
    >
      <span className={'share-icon-group'}>
        <i className={'icon icon-share'} />
      </span>
    </button>
  );
};

export default ShareButton;
